import React from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";

/**
 * Overlay is just a wrapper for a RecatPortal.
 * Anything which needs to display on top of the rest of the app
 *   should be wrapped in an Overlay.
 * More accurately, anything which needs to break out of its container.
 * If you need to prevent user interaction behind the Overlay, consider
 *   using Modal instead.
 */
export default class Overlay extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired
  }

  render() {
    const overlayRoot = document.getElementById("overlay_root");    
    if (!overlayRoot) return null; // Prevent crash in tests or SSR

    return createPortal(this.props.children, overlayRoot);
  }

}



// WEBPACK FOOTER //
// ./src/components/Overlay.js